import MailSource from "@/domain/enums/MailSource";
import SmartLabel from "@/domain/enums/SmartLabel";

export const smartLabelRootUrl = "smart-label";
export const customViewRootUrl = "custom-views";

const routes = {
    root: "/",
    dashboard: "/dashboard",
    inbox: `/${MailSource.Inbox}`,
    sent: `/${MailSource.SentItems}`,
    treated: `/${MailSource.Archive}`,
    draft: `/${MailSource.Drafts}`,
    trash: `/${MailSource.Deleteditems}`,
    spam: `/${MailSource.JunkEmail}`,
    smartLabel: `/${smartLabelRootUrl}/*`,
    customViews: `/${customViewRootUrl}/*`,
    askConsent: "/ask-consent",
    vistassistant: "/vistassistant",
    selectLicense: "/select-license",
    enterpriseForm: "/enterprise-form",
    success: "/success",
    cancel: "/cancel",
    notFound: "*",
};

export const modaleConfig = {
    pathWhenModalClosed: routes.dashboard,
    defaultPathWhenModalOpened: `/${smartLabelRootUrl}/${SmartLabel.Focus}`,
    modalPaths: [
        routes.inbox,
        routes.sent,
        routes.treated,
        routes.draft,
        routes.trash,
        routes.spam,
        smartLabelRootUrl,
        customViewRootUrl,
    ],
};

export default routes;
